export const LOAD_COUNTRY = '@countries/LOAD_COUNTRY';
export type LOADCOUNTRY = typeof LOAD_COUNTRY;

export interface SetCountry {
  type: LOADCOUNTRY;
  payload: {
    selectedCountry: null
  }
}

export function setCountry(selectedCountry: any): SetCountry {
  return {
    type: LOAD_COUNTRY,
    payload: {
      selectedCountry: selectedCountry
    }
  };
}